class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }
}
customElements.define("m-footer", MFooter);
